import { render, staticRenderFns } from "./HomeSchoolBar.vue?vue&type=template&id=192a68c1&scoped=true&"
import script from "./HomeSchoolBar.vue?vue&type=script&lang=js&"
export * from "./HomeSchoolBar.vue?vue&type=script&lang=js&"
import style0 from "./HomeSchoolBar.vue?vue&type=style&index=0&id=192a68c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192a68c1",
  null
  
)

export default component.exports